import { useState } from "react";
import styles from "./EndUser.module.css";
import { GoCheck } from "react-icons/go";
import { IoChevronDownOutline } from "react-icons/io5";

const currSymbols = () => {
  return {
    USD: "$",
    AED: "د.إ",
    AFN: "؋",
    ALL: "L",
    AMD: "֏",
    ANG: "ƒ",
    AOA: "Kz",
    ARS: "$",
    AUD: "$",
    AWG: "ƒ",
    AZN: "₼",
    BAM: "KM",
    BBD: "$",
    BDT: "৳",
    BGN: "лв",
    BIF: "FBu",
    BMD: "$",
    BND: "$",
    BOB: "Bs.",
    BRL: "R$",
    BSD: "$",
    BWP: "P",
    BYN: "Br",
    BZD: "$",
    CAD: "$",
    CDF: "FC",
    CHF: "CHF",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    CRC: "₡",
    CVE: "$",
    CZK: "Kč",
    DJF: "Fdj",
    DKK: "kr",
    DOP: "$",
    DZD: "د.ج",
    EGP: "£",
    ETB: "Br",
    EUR: "€",
    FJD: "$",
    FKP: "£",
    GBP: "£",
    GEL: "₾",
    GIP: "£",
    GMD: "D",
    GNF: "FG",
    GTQ: "Q",
    GYD: "$",
    HKD: "$",
    HNL: "L",
    HTG: "G",
    HUF: "Ft",
    IDR: "Rp",
    ILS: "₪",
    INR: "₹",
    ISK: "kr",
    JMD: "$",
    JPY: "¥",
    KES: "KSh",
    KGS: "сом",
    KHR: "៛",
    KMF: "CF",
    KRW: "₩",
    KYD: "$",
    KZT: "₸",
    LAK: "₭",
    LBP: "ل.ل",
    LKR: "Rs",
    LRD: "$",
    LSL: "L",
    MAD: "MAD",
    MDL: "L",
    MGA: "Ar",
    MKD: "ден",
    MMK: "K",
    MNT: "₮",
    MOP: "P",
    MUR: "₨",
    MVR: "Rf",
    MWK: "MK",
    MXN: "$",
    MYR: "RM",
    MZN: "MT",
    NAD: "$",
    NGN: "₦",
    NIO: "C$",
    NOK: "kr",
    NPR: "₨",
    NZD: "$",
    PAB: "B/.",
    PEN: "S/",
    PGK: "K",
    PHP: "₱",
    PKR: "₨",
    PLN: "zł",
    PYG: "₲",
    QAR: "ر.ق",
    RON: "lei",
    RSD: "дин",
    RUB: "₽",
    RWF: "FRw",
    SAR: "ر.س",
    SBD: "$",
    SCR: "₨",
    SEK: "kr",
    SGD: "$",
    SHP: "£",
    SLE: "Le",
    SOS: "Sh",
    SRD: "$",
    STD: "Db",
    SZL: "L",
    THB: "฿",
    TJS: "ЅМ",
    TOP: "T$",
    TRY: "₺",
    TTD: "$",
    TWD: "NT$",
    TZS: "Sh",
    UAH: "₴",
    UGX: "USh",
    UYU: "$",
    UZS: "so'm",
    VND: "₫",
    VUV: "VT",
    XAF: "FCFA",
    XCD: "$",
    XOF: "CFA",
    XPF: "₣",
    YER: "﷼",
    ZAR: "R",
    ZMW: "ZK",
  };
};

function MarketPlaceT1({
  selected,
  selectInterval,
  plans,
  features,
}) {
  /* Show T1 Card */
  const currencySymbols = currSymbols();
  const [openSections, setOpenSections] = useState([]);

  const toggleFeatures = (name) => {
    setOpenSections((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name],
    );
  };

  return (
    <div className={styles.mainContainer}>
      {/* Plans */}
      {plans.length > 0 ? (
        <div className={styles.price_container_wrapper}>
          <h1 className={styles.priceHeading}>MarketPlace Plans</h1>
          <div className={styles.plan_wrapper}>
            <div className={styles.blankPlan}></div>
            {plans
              .filter(
                (item) =>
                  item.typeId === selected && item.interval === selectInterval,
              )
              .map((product) => {
                const unitPrice = product?.unit_ids?.[0];
                const price = Number(unitPrice?.Marketplace_price ?? 0);
                const isFree = price === 0;
                const isOneTime = product?.interval === "1lifetime";

                const currencySymbol =
                  currencySymbols[product?.currency?.toUpperCase()];
                const intervalLabel = isOneTime ? "One Time" : currencySymbol;
                return (
                  <form key={product.id} className={styles.price_card}>
                    <div className={styles.pricing_card_circle_top_left} />
                    <div className={styles.pricing_card_circle_bottom_right} />
                    {/* Name */}
                    <div className={styles.label}>{product.name}</div>
                    {/* Description */}
                    <div className={styles.plan_description}>
                      {product.description.length > 120
                        ? product.description.slice(0, 120) + "..."
                        : product.description}
                      <span
                        className={styles.read_more}
                      >
                        {product.description?.length > 120 && "Read more"}
                      </span>
                    </div>
                    {/* Price */}
                    <div className={styles.price_container}>
                      {isFree ? (
                        <span
                          className={`${styles.price} ${styles.price_free}`}
                        >
                          Free
                        </span>
                      ) : (
                        <div className={styles.price_wrapper}>
                          <span className={styles.price}>{price}</span>
                          <span className={styles.price_interval}>
                            /{intervalLabel}
                          </span>
                        </div>
                      )}
                    </div>
                    {isFree && isOneTime && (
                      <div className={styles.sub_description}>
                        One-time purchase
                      </div>
                    )}
                    {/* Billing */}
                    {!isFree && !isOneTime && (
                      <div className={styles.sub_description}>
                        (Annual subscription – auto renews)
                        <span className={styles.sub_descriptionPlus}>+</span>
                      </div>
                    )}
                    {/* Buttons */}
                    <div className={styles.button_container}>
                      <button
                        type="button"
                        className={`${styles.plan_button} ${
                          isFree ? styles.btn_free : styles.btn_buy
                        }`}
                      >
                        {isFree ? <span>Get Free</span> : <span>Buy Now</span>}
                      </button>
                    </div>
                    <p className={styles.breakLine} />
                    {/* Highlights */}
                    <div className={styles.plan_feature_heading}>
                      <p>Plan highlights</p>
                    </div>
                    <ul className={styles.plan_features}>
                      {product.plan_highlight?.map((item, i) => (
                        <li key={i} className={styles.listbrief}>
                          <GoCheck />
                          <p>{item}</p>
                        </li>
                      ))}
                    </ul>
                  </form>
                );
              })}
            {/* Contact us after plan  */}
            {plans
              .filter(
                (item) =>
                  item.typeId === selected &&
                  item.interval === selectInterval &&
                  item.plan_type === "contact",
              )
              .map((product) => {
                return (
                  <form key={product.id} className={styles.contactUs_card}>
                    <div className={styles.pricing_card_circle_top_left} />
                    <div className={styles.pricing_card_circle_bottom_right} />
                    <div className={styles.contactusName}>Enterprise</div>
                    <div className={styles.contactTalk}>Let's talk</div>
                    {/* Button*/}
                    <button type="button" className={styles.contactus_btn}>
                      Contact us
                    </button>
                    <p className={styles.breakLine} />
                    {/* plan Highlights */}
                    {product?.plan_highlight?.length > 0 && (
                      <>
                        <div className={styles.plan_feature_heading}>
                          <p>All Features mentioned and:</p>
                        </div>
                        <ul className={styles.plan_features}>
                          {product.plan_highlight.map(
                            (item, i) => (
                              <li key={i} className={styles.listbrief}>
                                <GoCheck />
                                <p>{item}</p>
                              </li>
                            ),
                          )}
                        </ul>
                      </>
                    )}
                  </form>
                );
              })}
          </div>
        </div>
      ) : (
        <div className={styles.emptyData}>No Available Plans</div>
      )}
      {/* Features */}
      {features.length > 0 && (
        <div className={styles.featuresWrapper}>
          <div className={styles.heading}>Features</div>
          <div className={styles.featuresGrid}>
            {features.map((feature, i) => (
              <div key={i} className={styles.featureCard}>
                <div
                  className={styles.productInfo}
                  onClick={() => toggleFeatures(feature.name)}
                >
                  <h2 className={styles.featureName}>{feature.name}</h2>
                  <IoChevronDownOutline
                    className={` ${styles.downIcon} 
                    ${
                      openSections.includes(feature.name)
                        ? styles.rotateIcon
                        : ""
                    }`}
                  />
                </div>
                {/* Row title + value */}
                {openSections.includes(feature.name) && (
                  <div className={styles.featureContainer}>
                    {feature.data.map((label, index) => (
                      <div key={label} className={styles.featureField}>
                        {/* Left label */}
                        <p className={styles.featureTitle}>{label}</p>
                        {/* Values per plan */}
                        {plans?.map((plan) => {
                          const value = plan?.features?.find(
                            (f) => f.name === feature.name,
                          )?.data?.[index];
                          return (
                            <p key={plan.id} className={styles.featureValue}>
                              {value ?? "-"}
                            </p>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default MarketPlaceT1;
